import { render } from "./AddedToBasket.vue?vue&type=template&id=bc1f96ae&scoped=true"
import script from "./AddedToBasket.vue?vue&type=script&lang=js"
export * from "./AddedToBasket.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc1f96ae"]])

export default __exports__